module.exports = __webpack_public_path__ + "img/9.60c9833a.png";